import { store } from "@dinahmoe/dmafjs-core";

import { WebAudioNode } from "./node.js";

class WebAudioNodeConvolver extends WebAudioNode {
  namespace = "webaudio:node:convolver";

  init(node) {
    if (!store.get(`assets.buffer.${node.props.impulseId}`)) {
      console.warn(
        "Convolver impulseId",
        node.props.impulseId,
        "is not loaded"
      );
    }
    super.init(node);
  }
}

const webAudioNodeConvolver = new WebAudioNodeConvolver();
export { webAudioNodeConvolver, WebAudioNodeConvolver };
